import p from 'x/config/platform-specific'

const XBarChart = p.comp.getXBarChart()

export default XBarChart
